<template>
	<div
		class="flex flex-col app-input-container"
		:class="{ 'has-error': validation.errors.length > 0, [containerClass]: containerClass }"
	>
		<div class="relative w-full justify-center">
			<transition name="slide-fade" mode="out-in">
				<app-label
					:class="placeholderClass"
					v-if="modelValue !== null && modelValue !== undefined && modelValue !== '' && !hideLabel"
					:for="name"
					:color="validation.errors.length > 0 ? 'primary' : 'secondary'"
				>
					{{ placeholder }}
				</app-label>
			</transition>
			<app-icon v-if="!!icon" class="app-input-icon " style="line-height: 38px;" :icon="icon" />
			<textarea
				class="app-text-area"
				:class="!!icon ? 'has-icon' : ''"
				v-bind="$attrs"
				:placeholder="placeholder"
				:value="modelValue"
				@input="internalHandleChange"
				@blur="validation.setTouched && validation.setTouched(true)"
				:rows="rows"
				:maxlength="maxlength"
			/>
			<transition name="slide-fade-reverse">
				<span
					class="error-message text-13 text-error"
					v-if="(validation.meta.touched || validation.errors.length > 0) && !hideLabel"
				>
					{{ validation.errorMessage }}
				</span>
			</transition>
		</div>
	</div>
</template>

<script>
	import AppLabel from '@/components/typography/AppLabel';
	import AppIcon from '@/components/app/AppIcon';

	export default {
		name: 'AppTextArea',
		components: {
			AppLabel,
			AppIcon,
		},
		emits: ['update:modelValue'],
		props: {
			icon: {
				type: String,
				default: null,
			},
			name: {
				type: String,
				required: true,
			},
			placeholder: {
				type: String,
				default: '',
			},
			modelValue: {},
			validation: {
				type: Object,
				default: () => ({
					meta: {},
					errors: [],
				}),
			},
			hideLabel: {
				type: Boolean,
				default: false,
			},
			containerClass: {},
			rows: {
				type: [Number, String],
				default: 3,
			},
			placeholderClass: {
				type: String,
				default: 'text-secondary',
			},
			maxlength: {
				type: [Number, String],
				default: 300,
			},
		},
		setup(props, { emit }) {
			function internalHandleChange($event) {
				emit('update:modelValue', $event.target.value);
			}

			return {
				internalHandleChange,
			};
		},
	};
</script>
